import { WebRTCAdaptor } from "./adaptors-0.0.5/webrtc_adaptor.js";
import { getUrlParameter } from "./helpers-0.0.1/fetch.stream.js";
import { LocalStorageAdaptor } from "./adaptors-0.0.5/storage.js";
import { ErrorLogger } from "./helpers-0.0.1/error_logging.js";
import "./libs/url-search-params-polyfill.js";
import evaluateConnectionAndReturnScoring from "./utils/evaluateConnectionAndReturnScoring.js";
import { mediaConstraintsGenerator } from "./utils/mediaConstraintsGenerator.js";
import { v4 as uuid } from "uuid";
import jwt from "jsonwebtoken";
import {
  measureInputLevel,
  stopMeasuringInputLevel,
} from "./utils/measureInputLevel.js";

const ledsColorForMeter = [
  "#064dac",
  "#064dac",
  "#064dac",
  "#06ac5b",
  "#15ac06",
  "#4bac06",
  "#80ac06",
  "#acaa06",
  "#ac8b06",
  "#ac5506",
];

class UI {
  evaluateRotationBasedOnHeightAndWidth(height, width) {
    let result = "portrait";
    if (height && width && width > height) result = "landscape";
    return result;
  }
  getOrientation() {
    var orientation =
      window.innerWidth > window.innerHeight ? "landscape" : "portrait";
    return orientation;
  }
  constructor() {
    window.mobileCheck = function () {
      let check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    };

    // check if inside an iframe
    window.isInIframe = function () {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    };

    if (
      window.mobileCheck() &&
      !this.firstParentNotifiedOrientation &&
      !window.isInIframe()
    ) {
      window.onresize = () => {
        if (!this.firstParentNotifiedOrientation && this.initialOrientation) {
          if (this.getOrientation() !== this.initialOrientation) {
            // Not the initial orientation

            this.showChangedDeviceOrientationPopup();
          } else {
            console.log("calling hide from 1");
            this.hideChangedDeviceOrientationPopUp();
          }
        }
      };
    }

    setTimeout(() => {
      this.totalConnectionFailures = 0;
      this.consequentConnectionFailures = 0;
    }, 15 * 60 * 1000);
    this.state = "";
    const params = new URLSearchParams(document.location.href.split("?")[1]);
    this.avoidedServers = "";
    if (params.get("avoidServers")) {
      this.avoidedServers = params.get("avoidServers");
    }
    this.showId = null;
    if (params.get("showId")) {
      this.showId = params.get("showId");
    }
    this.volumeMeterEnabled = false;
    this.latestUnreportedStats = null;
    this.currentSessionUID = uuid();
    this.lastNotifiedMuteStatusToParent = "unmuted";
    this.consequentConnectionFailures = 0;
    this.totalConnectionFailures = 0;
    this.numberOfDevicesEnumerationsDueToDisconnections = 0;
    this.webRTCAdaptor = undefined;
    // this.maxVideoBitrateKbps = 1900; // Default to 1080p max
    this.maxVideoBitrateKbps = "unlimited"; // Default to 1080p max

    this.availableAudioDevicesId = [];
    this.availableVideoDevicesId = [];
    this.selectedAudioDeviceId = null;
    this.selectedVideoDeviceId = null;
    this.lastPacketlost = 0;
    this.infoMessageInVideoExpirationTimeout = null;
    this.latestEndpointUpdatedPublishingServer = null;
    this.reportedHardwareFailures = 0;
    this.reportedStatusCheckerInterval = null;
    this.lastReportedState = null;
    this.firstParentNotifiedOrientationDirectly = "portrait";
    if (getUrlParameter("bitrate")) {
      this.maxVideoBitrateKbps = parseInt(getUrlParameter("bitrate"));
    }
    /** If publishing stops for any reason, it tries to republish again. */
    this.autoRepublishEnabled = true;
    /** Timer job that checks the WebRTC connection */
    this.autoRepublishIntervalJob = null;
    /** Token stream */
    this.token = getUrlParameter("tc");

    this.publishImmediately = getUrlParameter("publishImmediately");
    // this.websocketUrl = decodeURIComponent(getUrlParameter("url"));
    this.availableCodecs = ["vp8", "h264"];
    // this.availableCodecs = this.parseAvailableCodecs();
    this.alreadyInitialized = false;

    this.alreadyPublishing = false;
    this.lastStats = null;
    this.mainConfigurationBlock = document.querySelector(
      ".atv_mainConfiguration"
    );
    this.settingsButtons = document.querySelector(".atv_settingsButton");
    this.captureButton = document.querySelector(".atv_captureButton");
    this.checkboxMic = document.querySelector(".atv_switch_mic");
    this.iconMic = document.querySelector(".atv_toggleMuteButton");
    this.checkboxMirrorMode = document.querySelector(".atv_mirror_mode");
    this.videoSelector = document.querySelector(".atv_webrtc_video_selector");
    this.videoSelector.addEventListener("change", (event) => {
      const item = event.target;
      this.switchVideoMode(item.value);
    });

    this.audioSelector = document.querySelector(".atv_webrtc_audio_selector");
    this.audioSelector.addEventListener("change", (event) => {
      const item = event.target;
      this.switchAudioMode(item.value);
    });

    this.localVideo = document.querySelector("#localVideo");
    this.popUpOptions = document.querySelector("#popUpOptions");
    this.cameraAudioMultipleErrorsPopUp = document.querySelector(
      "#cameraAudioMultipleErrorsPopUp"
    );
    this.changedDeviceOrientationPopUp = document.querySelector(
      "#changedDeviceOrientationPopUp"
    );

    this.videoContainer = document.querySelector(".atv_videoContainer");
    this.maxBandwidthTextBox = document.querySelector("#maxBandwidthTextBox");
    this.maxBandwidthApply = document.querySelector("#max_bandwidth_apply");
    this.localStorage = new LocalStorageAdaptor();
    this.isMicMuted =
      !!this.localStorage && !!this.localStorage.getMicMutedValue();
    this.takeCaptureInterval = null;
    this.takeCaptureIntervalCounter = 0;
    this.__messageToVideo(translations.INITIALIZING);
    this.lastReportedState = "INITIALIZING";

    this.signalBars = document.querySelector(".signal-bars");

    this.initCloseSettingsModalButton();
    this.initCloseNoDevicesModalButton();
    this.initSwitchMuteUnmuteMicrophone();
    this.initSwitchMirrorMode();
    this.initIconMuteUnmuteMicrophone();
    this.initStartPublishingButton();
    this.initStopPublishingButton();
    this.initBitrateForm();
    this.initConfigButton();
    this.initCaptureButton();

    this.listenParent();
    this.listenRefreshRequests();

    if (!appName || !streamName) {
      if (this.token) {
        const decodedToken = jwt.decode(this.token);
        if (decodedToken) {
          appName = decodedToken.appName;
          streamName = decodedToken.streamName;

          this.streamId = decodedToken.streamName;
        }
      }
    } else {
      this.streamId = streamName;
    }
    this.updateDeviceList().then(() => {
      navigator.mediaDevices.ondevicechange = () => {
        this.updateDeviceList();
      };

      this.getPublishingServerFromLB()
        .then((server) => {
          publishingServer = server;
          this.websocketUrl = this.generateWebSocketUrl(
            publishingServer,
            webrtcSSLPublishingPort,
            webrtcNotSSLPublishingPort,
            appName
          );
          this.initWebRTCAdaptor();
        })
        .catch((err) => {
          alert("Error trying to get publishing server: " + err.toString());
        });
    });

    this.localVideo.addEventListener("loadedmetadata", () => {
      this.onVideoMetadataEvent();
    });
  }

  updateSignalBars(strength = 4) {
    this.signalBars.classList.remove("one-bar");
    this.signalBars.classList.remove("two-bars");
    this.signalBars.classList.remove("three-bars");
    this.signalBars.classList.remove("four-bars");
    this.signalBars.classList.remove("ok");
    this.signalBars.classList.remove("bad");
    this.signalBars.classList.remove("good");
    this.signalBars.classList.remove("hideMe");

    switch (strength) {
      case 0:
        this.signalBars.classList.add("hideMe");
        break;
      case 1:
        this.signalBars.classList.add("one-bar");
        this.signalBars.classList.add("bad");
        break;
      case 2:
        this.signalBars.classList.add("two-bars");
        this.signalBars.classList.add("bad");
        break;
      case 3:
        this.signalBars.classList.add("three-bars");
        this.signalBars.classList.add("ok");
        break;
      case 4:
        this.signalBars.classList.add("four-bars");
        this.signalBars.classList.add("good");
        break;
      case 5:
      default:
        this.signalBars.classList.add("five-bars");
        this.signalBars.classList.add("good");
        break;
    }
  }

  startTakeCaptureInterval(intervalInSeconds = 15) {
    console.log("TAKE CAPTURE DISABLED:" + isTakeLocalCaptureDisabled);
    if (isTakeLocalCaptureDisabled) return;
    this.stopTakeCaptureIfPending();
    this.takeCaptureIntervalCounter = 0;

    if (areTakeLocalCaptureActionsVisible)
      this.__infoToVideo(
        translations["TAKING_CAPTURE_IN"] + intervalInSeconds,
        "WARNING"
      );
    this.takeCaptureInterval = setInterval(() => {
      if (intervalInSeconds - this.takeCaptureIntervalCounter === 1) {
        this.takeCapture();
        this.stopTakeCaptureIfPending();
      } else {
        this.takeCaptureIntervalCounter++;
        if (areTakeLocalCaptureActionsVisible)
          this.__infoToVideo(
            translations["TAKING_CAPTURE_IN"] +
              (intervalInSeconds - this.takeCaptureIntervalCounter),
            "WARNING"
          );
      }
    }, 2000);
  }

  stopTakeCaptureIfPending() {
    if (this.takeCaptureInterval) {
      clearInterval(this.takeCaptureInterval);
      this.__infoToVideo(null);
    }
  }
  submitLocalStreamStatsIfAnythingToReport() {
    try {
      if (this.latestUnreportedStats) {
        if (this.webRTCAdaptor && this.webRTCAdaptor.webSocketAdaptor) {
          this.webRTCAdaptor.webSocketAdaptor.send(
            JSON.stringify({
              command: "collectLocalStreamStats",
              stats: this.latestUnreportedStats,
            })
          );
        }
      }
    } catch (err) {
      console.error(
        "Error trying submit local stream stats: " + err.toString()
      );
    }
  }
  takeCapture() {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = this.localVideo.videoWidth;
      canvas.height = this.localVideo.videoHeight;
      if (
        (/iPhone/.test(navigator.userAgent) ||
          /iPad/.test(navigator.userAgent)) &&
        ((this.firstParentNotifiedOrientation &&
          this.firstParentNotifiedOrientation === "portrait") ||
          (!this.firstParentNotifiedOrientation &&
            this.initialOrientation === "portrait"))
      ) {
        canvas.width = this.localVideo.videoHeight;

        canvas.height = this.localVideo.videoWidth;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(this.localVideo, 0, 0, canvas.width, canvas.height);
      } else {
        const ctx = canvas.getContext("2d");

        ctx.drawImage(this.localVideo, 0, 0, canvas.width, canvas.height);
      }
      const dataURI = canvas.toDataURL("image/jpeg");
      if (this.webRTCAdaptor && this.webRTCAdaptor.webSocketAdaptor) {
        this.webRTCAdaptor.webSocketAdaptor.send(
          JSON.stringify({
            command: "uploadCapture",
            capture: dataURI,
          })
        );
      }
    } catch (err) {
      console.error("Error trying to take capture: " + err.toString());
    }
  }

  getPublishingServerFromLB(avoidServers = null) {
    return new Promise((resolve, reject) => {
      // resolve("f-stream-origin-internal-ovh-us-1.vtsmedia.com");
      // return;
      if (forcedServer) {
        resolve(forcedServer);
        return;
      }
      fetch(
        urlToGetPublishingServer +
          (avoidServers ? `?avoidServers=${avoidServers}` : ""),
        {
          mode: "cors",
        }
      )
        .then(async (res) => {
          if (!res.ok) {
            reject("Error occurred trying to get streamingServer.");
            return;
          }

          const server = await res.json();
          if (!server || !server.publishingServer) {
            reject("No publishing server found");
            return;
          }
          console.log("Retrieved server from LB: " + server.publishingServer);
          resolve(server.publishingServer);
        })
        .catch((err) => {
          reject("Error occurred trying to get streamingServer.");
        });
    });
  }

  enumerateDevices(kind) {
    return new Promise((resolve, reject) => {
      navigator.mediaDevices
        .enumerateDevices()
        .then(function (devices) {
          let devs = [];
          devices.forEach(function (device) {
            if (device.kind === kind) {
              console.log(
                device.kind + ": " + device.label + " id = " + device.deviceId
              );
              devs = [...devs, device];
            }
          });
          setTimeout(() => resolve(devs), 500);
        })
        .catch(function (err) {
          setTimeout(() => {
            reject(err);
          }, 500);
        });
    });
  }
  timeToSleep(i) {
    const l = Math.max(1, i);
    return l * 1000;
  }
  generateWebSocketUrl(serverName, sslPort, notSSLPort, appName) {
    const isIphone = [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform);
    // if (isIphone) env = env + 'transcoded';
    var path =
      serverName +
      ":" +
      // (location.protocol.startsWith('https') ? sslPort : notSSLPort) +
      sslPort +
      "/" +
      appName +
      "/" +
      "websocket?fragStreamBy=VisionTS";
    // var websocketURL = 'ws://' + path;
    // if (location.protocol.startsWith('https')) {
    var websocketURL = "wss://" + path;
    // }
    return websocketURL;
  }

  initWebRTCAdaptor() {
    this.state = "INIT";

    // if (window.mobileCheck() && this.webRTCAdaptor) {
    if (this.webRTCAdaptor) {
      this.webRTCAdaptor.initialize();
    } else {
      // this.selectedVideoDeviceId = null;
      // this.selectedAudioDeviceId = null;
      // if (this.webRTCAdaptor) {
      // 	this.webRTCAdaptor.initialize();
      // } else {
      this.webRTCAdaptor = new WebRTCAdaptor({
        websocket_url: this.websocketUrl,
        mediaConstraints: mediaConstraintsGenerator(
          this.selectedVideoDeviceId,
          this.selectedAudioDeviceId
        ),
        peerconnection_config: {
          // iceTransportPolicy: "relay",
          iceServers: [
            {
              urls: "stun:stun.l.google.com:19302",
            },
            // {
            //   urls: "turn:turn.a0s.net:5349",
            //   username: "guest",
            //   credential: "somepassword",
            // },
            // {
            //   urls: "turn:191.232.209.103:5349",
            //   username: "guest",
            //   credential: "somepassword",
            // },
          ],
        },
        sdp_constraints: {
          OfferToReceiveAudio: false,
          OfferToReceiveVideo: false,
        },
        localVideoId: "localVideo",
        debug: true,
        bandwidth: this.maxVideoBitrateKbps,
        availableCodecs: this.availableCodecs,
        callback: (info, obj) => {
          switch (info) {
            case "websocket_connection_closed":
              this.onConnectionClosed();
              break;
            case "video_stream_track_ended":
              this.selectedVideoDeviceId = null;
              this.updateDeviceList();
              console.log("VIDEO STREAM TRACK ENDED");
              break;
            case "audio_stream_track_ended":
              this.selectedAudioDeviceId = null;
              this.updateDeviceList();

              console.log("AUDIO STREAM TRACK ENDED");
              break;
            case "requestLocalCapture":
              this.startTakeCaptureInterval(5);
              break;
            case "requestLocalStreamStats":
              this.submitLocalStreamStatsIfAnythingToReport();
              break;
            case "notifyNoPermissionsForCapture":
              if (areTakeLocalCaptureActionsVisible)
                this.__infoToVideo(
                  translations["NO_PERMISSIONS_FOR_CAPTURE"],
                  "WARNING",
                  false,
                  2000
                );
              break;
            case "connecting":
              this.onConnecting();
              break;
            case "connected":
              this.onConnected(obj);
              break;
            case "publish_started":
              this.onPublishStarted(obj);
              break;
            case "publish_finished":
              this.onPublishFinished(obj);
              break;
            case "ice_connection_state_changed":
              this.onIceConnectionStateChanged(obj);
              break;
            case "updated_stats":
              this.onUpdatedStats(obj);
              break;
            case "available_devices":
              this.onAvailableDevices(obj);
              break;
          }
        },
        callbackError: (error, errorDescription) => {
          if (typeof error !== "string") {
            console.error(error);
            return;
          }

          var errorMessage = error;
          if (error.indexOf("NotFoundError") !== -1) {
            errorMessage =
              "Camera or Mic are not found or not allowed in your device";
            this.__messageToVideo(translations.NO_DEVICES_FOUND);
            this.lastReportedState = "NO_DEVICES_FOUND";

            this.localStorage.setVideoDeviceId(null);
            this.localStorage.setAudioDeviceId(null);
          } else if (
            error.indexOf("NotReadableError") !== -1 ||
            error.indexOf("TrackStartError") !== -1
          ) {
            console.log(error);
            errorMessage =
              "Camera or Mic is being used by some other process that does not let read the devices";
            //this.__messageToVideo(translations.DEVICES_BEING_USED);
            // this.hideOptions();
            // this.showMultipleAudioVideoDevicesErrorPopUp();
            alert("Camera is being used, please select a different one.");
            this.showOptions();
          } else if (
            error.indexOf("OverconstrainedError") !== -1 ||
            error.indexOf("ConstraintNotSatisfiedError") !== -1
          ) {
            errorMessage =
              "There is no device found that fits your video and audio constraints. You may change video and audio constraints";
            this.localStorage.setVideoDeviceId(null);
            this.localStorage.setAudioDeviceId(null);
            this.__messageToVideo(translations.NO_DEVICES_FOUND);
            this.lastReportedState = "NO_DEVICES_FOUND";
          } else if (
            error.indexOf("NotAllowedError") !== -1 ||
            error.indexOf("PermissionDeniedError") !== -1
          ) {
            errorMessage = "You are not allowed to access camera and mic.";
            this.__messageToVideo(translations.PERMISSIONS_DENIED);
            this.lastReportedState = "PERMISSIONS_DENIED";

            this.showMultipleAudioVideoDevicesErrorPopUp();
            this.hideOptions();
          } else if (error.indexOf("TypeError") !== -1) {
            errorMessage = "Video/Audio is required";
            this.__messageToVideo(translations.PERMISSIONS_DENIED);
            this.lastReportedState = "PERMISSIONS_DENIED";
            this.showMultipleAudioVideoDevicesErrorPopUp();
            this.hideOptions();
          } else if (error.indexOf("WebSocketNotConnected") !== -1) {
            errorMessage = "WebSocket Connection is disconnected.";
            // this.__messageToVideo('WebSocket Not Connected');
          } else if (error.indexOf("WebSocketError") !== -1) {
            errorMessage = "WebSocket Connection Error";
            this.__messageToVideo(translations.WS_ERROR);
            this.lastReportedState = "WS_ERROR";
            this.messageToParent("websocket_error");
          } else if (error.indexOf("CodecNotSupported") !== -1) {
            errorMessage = "This device has no supported video codec";
            this.__messageToVideo(translations.DEVICE_NOT_SUPPORTED);
            this.lastReportedState = "DEVICE_NOT_SUPPORTED";
            this.notCompatibleDeviceError();
          } else if (
            error === "Error" &&
            errorDescription === "INVALID_AUDIO_DEVICE"
          ) {
            this.__messageToVideo(translations.INVALID_AUDIO_DEVICE);
            this.lastReportedState = "INVALID_AUDIO_DEVICE";
            this.localStorage.setVideoDeviceId(null);
            this.localStorage.setAudioDeviceId(null);
            errorMessage =
              "Tried to get user media from an invalid audio device";
            this.messageToParent("invalid_audio_device");
          } else if (errorDescription === "Invalid constraint") {
            // message: "Invalid constraint"
            this.__messageToVideo(translations.INVALID_CONTRAINTS);
            this.lastReportedState = "INVALID_CONSTRAINTS";
            this.localStorage.setVideoDeviceId(null);
            this.localStorage.setAudioDeviceId(null);
          }

          console.warn(errorMessage);
        },
      });
      // }
    }
  }

  initStartPublishingButton() {
    this.startPublishPlaceholder = document.querySelector(".atv_start_tip");
    this.startPublish = document.querySelector(".atv_start_transmit");
    if (this.startPublish) {
      this.startPublish.addEventListener("click", () => {
        this.startPublishing();
        this.messageToParent("user_clicked_publish");
      });
    }
  }
  initStopPublishingButton() {
    this.stopPublish = document.querySelector(".atv_stop_transmit");
    if (this.stopPublish) {
      this.stopPublish.addEventListener("click", () => {
        this.stopPublishing();
        this.messageToParent("user_clicked_finish");
      });
    }
  }

  initCloseSettingsModalButton() {
    this.closeButton = document.querySelector("#close_button");
    this.closeButton.addEventListener("click", () => {
      this.toggleOptions();
    });
  }

  initCloseNoDevicesModalButton() {
    this.closeButtonNoDevices = document.querySelector(
      "#close_button_no_device"
    );
    this.closeButtonNoDevices.addEventListener("click", () =>
      this.hideMultipleAudioVideoDevicesErrorPopUp()
    );
  }

  initIconMuteUnmuteMicrophone() {
    var self = this;
    if (this.iconMic) {
      this.iconMic.addEventListener("click", function () {
        if (self.checkboxMic && !self.checkboxMic.checked) {
          self.muteMic();
        } else {
          self.unmuteMic();
        }
      });
    }
  }
  initSwitchMuteUnmuteMicrophone() {
    var self = this;
    if (this.checkboxMic) {
      this.checkboxMic.addEventListener("change", function () {
        if (this.checked) {
          self.muteMic();
        } else {
          self.unmuteMic();
        }
      });
    }
  }

  initSwitchMirrorMode() {
    var self = this;
    if (this.checkboxMirrorMode) {
      this.checkboxMirrorMode.addEventListener("change", function () {
        self.toggleMirrorMode();
      });
    }
  }

  startPublishing() {
    this.webRTCAdaptor.publish(this.streamId, this.token);
    this.hideStartPublishButton();
    this.enableStopPublishButton();
    this.hideOptions();
    if (this.reportedStatusCheckerInterval) {
      clearInterval(this.reportedStatusCheckerInterval);
      this.reportedStatusCheckerInterval = null;
    }
    const self = this;
    this.reportedStatusCheckerInterval = setInterval(() => {
      if (
        self.lastReportedState === "READY" ||
        self.lastReportedState === "ENDED" ||
        self.lastReportedState === "WS_ERROR"
      ) {
        self.increaseErrorsCountAndEvaluateForwardToAnotherServer(true);
      } else {
        self.consequentConnectionFailures = 0;
      }
    }, 1000);
  }

  stopPublishing() {
    if (this.autoRepublishIntervalJob != null) {
      clearInterval(this.autoRepublishIntervalJob);
      this.autoRepublishIntervalJob = null;
    }

    if (this.reportedStatusCheckerInterval) {
      clearInterval(this.reportedStatusCheckerInterval);
      this.reportedStatusCheckerInterval = null;
    }
    this.alreadyPublishing = false;
    this.webRTCAdaptor.stop(this.streamId);
    this.webRTCAdaptor.closePeerConnection(this.streamId);
    // this.webRTCAdaptor.closeWebSocket();
    this.updateSignalBars(0);
    this.hideStopPublishButton();
    this.enableStartPublishButton();
  }

  muteMic() {
    this.localStorage.storeMicMuted();
    this.isMicMuted = true;
    this.checkboxMic.checked = true;
    if (this.iconMic.classList.contains("btn--toggle-mute-unmuted")) {
      this.iconMic.classList.remove("btn--toggle-mute-unmuted");
      this.iconMic.classList.add("btn--toggle-mute-muted");
    }
    this.iconMic.innerHTML =
      '<i class="fas fa-microphone-slash medium_blinker" style="color: rgba(255, 0, 0, 0.78);"></i>';
    this.webRTCAdaptor.muteLocalMic();
    if (this.lastNotifiedMuteStatusToParent !== "muted") {
      this.lastNotifiedMuteStatusToParent = "muted";
      this.messageToParent("mic_muted");
    }
  }

  unmuteMic() {
    this.isMicMuted = false;
    this.localStorage.storeMicUnMuted();
    this.checkboxMic.checked = false;
    if (this.iconMic.classList.contains("btn--toggle-mute-muted")) {
      this.iconMic.classList.remove("btn--toggle-mute-muted");
      this.iconMic.classList.add("btn--toggle-mute-unmuted");
    }
    this.iconMic.innerHTML =
      '<i class="fas fa-microphone" style="color: rgba(11, 115, 0, 0.82);"></i>';
    this.webRTCAdaptor.unmuteLocalMic();
    if (this.lastNotifiedMuteStatusToParent !== "unmuted") {
      this.lastNotifiedMuteStatusToParent = "unmuted";
      this.messageToParent("mic_unmuted");
    }
  }

  enableStartPublishButton() {
    if (this.startPublish) {
      this.startPublish.classList.remove("disabled");
      this.startPublish.classList.remove("hideMe");
      this.startPublish.disabled = false;
    }
    if (this.startPublishPlaceholder) {
      this.startPublishPlaceholder.classList.remove("disabled");
      this.startPublishPlaceholder.classList.remove("hideMe");
      this.startPublishPlaceholder.disabled = false;
    }
  }

  toggleMirrorMode() {
    if (this.localVideo.classList.contains("flip")) {
      this.localVideo.classList.remove("flip");
    } else {
      this.localVideo.classList.add("flip");
    }
  }

  disableStartPublishButton() {
    if (this.startPublish) {
      this.startPublish.classList.add("disabled");
      this.startPublish.disabled = true;
    }
    if (this.startPublishPlaceholder) {
      this.startPublishPlaceholder.classList.add("disabled");
      this.startPublishPlaceholder.classList.add("hideMe");
      this.startPublishPlaceholder.disabled = true;
    }
  }
  hideStartPublishButton() {
    if (this.startPublish) {
      this.startPublish.classList.add("hideMe");
    }
    if (this.startPublishPlaceholder) {
      this.startPublishPlaceholder.classList.add("hideMe");
    }
  }
  enableStopPublishButton() {
    if (this.stopPublish) {
      this.stopPublish.classList.remove("hideMe");
    }
  }
  hideStopPublishButton() {
    if (this.stopPublish) {
      this.stopPublish.classList.add("hideMe");
    }
  }
  removeLocalVideo() {
    if (this.localVideo) {
      this.localVideo.parentElement.removeChild(this.localVideo);
      this.localVideo = null;
    }
  }

  listenParent() {
    window.addEventListener(
      "message",
      (event) => {
        if (event) {
          var messageData = event.data;
          this.onParentMessage(messageData.type, messageData.data);
        }
      },
      false
    );
  }

  listenRefreshRequests() {
    const self = this;
    window.addEventListener(
      "refresh_connecting_to_same_server",
      (event) => {
        self.refreshConnectingToSameServer();
      },
      false
    );
  }

  onParentMessage(type, data) {
    switch (type) {
      case "showid":
        if (data && data.showid) {
          console.log("Received showId: " + data.showid);
          this.showId = data.showid;
        }
        break;

      case "initial_orientation":
        console.log("Received initial orientation: " + data.orientation);
        this.firstParentNotifiedOrientationDirectly = data.orientation;
        break;

      case "orientation_has_changed":
        if (!this.firstParentNotifiedOrientationDirectly) {
          this.firstParentNotifiedOrientationDirectly = data.orientation;
        } else {
          if (
            this.firstParentNotifiedOrientationDirectly !== data.orientation
          ) {
            this.showChangedDeviceOrientationPopup();
          } else {
            console.log("calling hide from 2");
            this.hideChangedDeviceOrientationPopUp();
          }
        }
        break;

      case "orientation_changed":
        // if (window.mobileCheck()) {
        let newOrientation = data.orientation;
        if (
          navigator.userAgent.match(/iPad/i) ||
          navigator.userAgent.match(/Mac/i)
        ) {
          console.log("[DBG] Trigger correction, received: " + newOrientation);
          if (newOrientation === "portrait") newOrientation = "landscape";
          else if (newOrientation === "landscape") newOrientation = "portrait";
          console.log("[DBG] Corrected to: " + newOrientation);
        }
        if (!this.firstParentNotifiedOrientationDirectly) {
          this.firstParentNotifiedOrientationDirectly = newOrientation;
        } else {
          if (this.firstParentNotifiedOrientationDirectly !== newOrientation) {
            this.showChangedDeviceOrientationPopup();
          } else {
            console.log("calling hide from 3  ");
            this.hideChangedDeviceOrientationPopUp();
          }
        }
        // }
        break;
      // case "initial_size":
      //   alert('initial size: ' + data.height + ' ' + data.width)
      //   this.firstParentNotifiedOrientation =
      //     this.evaluateRotationBasedOnHeightAndWidth(data.height, data.width);
      //   break;
      // case "resize":
      //   if (window.mobileCheck()) {
      //     if (!this.firstParentNotifiedOrientation) {
      //       this.firstParentNotifiedOrientation =
      //         this.evaluateRotationBasedOnHeightAndWidth(
      //           data.height,
      //           data.width
      //         );
      //     } else {
      //       if (
      //         this.firstParentNotifiedOrientation !==
      //         this.evaluateRotationBasedOnHeightAndWidth(
      //           data.height,
      //           data.width
      //         )
      //       ) {
      //         this.showChangedDeviceOrientationPopup();
      //       } else {
      //         this.hideChangedDeviceOrientationPopUp();
      //       }
      //     }
      //   }
      //   break;

      case "init":
        break;
      case "toggleOptions":
        this.toggleOptions();
        break;

      case "startStream":
        this.startPublishing();
        break;

      case "stopStream":
        this.stopPublishing();
        break;

      case "muteMic":
        this.lastNotifiedMuteStatusToParent = "muted";
        this.muteMic();
        break;

      case "unmuteMic":
        this.lastNotifiedMuteStatusToParent = "unmuted";
        this.unmuteMic();
        break;
    }
  }

  messageToParent(type, data) {
    console.log("Message to parent type " + type);
    parent.postMessage(JSON.stringify({ type, data, webrtc: true }), "*");
  }

  initBitrateForm() {
    if (this.maxBandwidthTextBox) {
      this.maxBandwidthTextBox.value = this.maxVideoBitrateKbps;
      this.maxBandwidthApply.addEventListener("click", () => {
        var bitrate = parseInt(this.maxBandwidthTextBox.value);
        this.updateBitrate(bitrate);
      });
    }
  }

  updateBitrate(bitrate) {
    if (Number.isNaN(bitrate) || bitrate < 100 || bitrate > 2500) {
      this.maxVideoBitrateKbps = 2000; // Default to 1080p
    } else {
      this.maxVideoBitrateKbps = bitrate;
    }
    console.log("input bitrate: " + this.maxVideoBitrateKbps);
    this.maxBandwidthTextBox.value = this.maxVideoBitrateKbps;
    if (this.webRTCAdaptor) {
      this.webRTCAdaptor.changeBandwidth(
        this.maxVideoBitrateKbps,
        this.streamId
      );
    }
  }

  switchVideoMode(deviceId, saveAsDefault = true) {
    this.selectedVideoDeviceId = deviceId;

    if (
      saveAsDefault &&
      deviceId !== "screen" &&
      deviceId !== "screen+camera" &&
      this.localStorage
    )
      this.localStorage.setVideoDeviceId(deviceId);
    if (this.webRTCAdaptor) {
      if (deviceId === "screen") {
        this.webRTCAdaptor.switchDesktopCapture(this.streamId);
      } else if (deviceId === "screen+camera") {
        this.webRTCAdaptor.switchDesktopCaptureWithCamera(this.streamId);
      } else {
        const self = this;
        this.webRTCAdaptor
          .switchVideoCameraCapture(
            this.streamId,
            mediaConstraintsGenerator(
              this.selectedVideoDeviceId,
              this.selectedAudioDeviceId
            )
          )
          .then(() => {
            setTimeout(() => {
              if (self.isMicMuted) {
                self.muteMic();
              }
            }, 500);
          });
      }
    }
  }

  onVideoMetadataEvent() {
    this.messageToParent("resolution_changed", {
      videoWidth: this.localVideo.videoWidth,
      videoHeight: this.localVideo.videoHeight,
    });
  }

  __infoToVideo(
    message,
    alertType = "WARNING",
    blinker = true,
    expirationInMs = null
  ) {
    if (this.infoMessageInVideoExpirationTimeout) {
      clearTimeout(this.infoMessageInVideoExpirationTimeout);
      this.infoMessageInVideoExpirationTimeout = null;
    }
    var lastMessage = this.videoContainer.querySelector(
      ".atv_webrtc_info_message"
    );
    if (!lastMessage) {
      this.videoContainer.insertAdjacentHTML(
        "afterbegin",
        '<div class="atv_webrtc_info_message webrtc_info_message hideMe" style="z-index: 1"></div>'
      );
    }

    lastMessage = this.videoContainer.querySelector(".atv_webrtc_info_message");
    if (message) {
      if (blinker) {
        if (!lastMessage.classList.contains("fast_blinker"))
          lastMessage.classList.add("fast_blinker");
      } else {
        lastMessage.classList.remove("fast_blinker");
      }
      lastMessage.textContent = message.toUpperCase();
      if (alertType === "SUCCESS") {
        lastMessage.classList.add("okColor");
        lastMessage.classList.remove("warningColor");
        lastMessage.classList.remove("errorColor");
      } else if (alertType === "ERROR") {
        lastMessage.classList.remove("okColor");
        lastMessage.classList.remove("warningColor");
        lastMessage.classList.add("errorColor");
      } else {
        lastMessage.classList.remove("okColor");
        lastMessage.classList.add("warningColor");
        lastMessage.classList.remove("errorColor");
      }
      lastMessage.classList.remove("hideMe");

      if (expirationInMs) {
        this.infoMessageInVideoExpirationTimeout = setTimeout(() => {
          this.__infoToVideo(null);
        }, expirationInMs);
      }
    } else {
      lastMessage.classList.add("hideMe");
    }
  }

  __alertToVideo(message, alertType = "WARNING") {
    var lastMessage = this.videoContainer.querySelector(
      ".atv_webrtc_warning_message"
    );
    if (!lastMessage) {
      this.videoContainer.insertAdjacentHTML(
        "afterbegin",
        '<div class="atv_webrtc_warning_message webrtc_warning_message hideMe" style="z-index: 1"></div>'
      );
    }

    lastMessage = this.videoContainer.querySelector(
      ".atv_webrtc_warning_message"
    );
    if (message) {
      lastMessage.textContent = message.toUpperCase();
      if (alertType === "SUCCESS") {
        lastMessage.classList.add("okColor");
        lastMessage.classList.remove("warningColor");
        lastMessage.classList.remove("errorColor");
      } else if (alertType === "ERROR") {
        lastMessage.classList.remove("okColor");
        lastMessage.classList.remove("warningColor");
        lastMessage.classList.add("errorColor");
      } else {
        lastMessage.classList.remove("okColor");
        lastMessage.classList.add("warningColor");
        lastMessage.classList.remove("errorColor");
      }
      lastMessage.classList.remove("hideMe");
    } else {
      lastMessage.classList.add("hideMe");
    }
  }

  __messageToVideo(message) {
    var lastMessage = this.videoContainer.querySelector(".atv_webrtc_message");
    if (!lastMessage) {
      this.videoContainer.insertAdjacentHTML(
        "afterbegin",
        '<div class="atv_webrtc_message webrtc_message hideMe" style="z-index: 1"></div>'
      );
    }

    lastMessage = this.videoContainer.querySelector(".atv_webrtc_message");
    if (message) {
      if (message !== translations.PUBLISHING) {
        this.__alertToVideo();
      }
      lastMessage.textContent = message.toUpperCase();
      lastMessage.classList.remove("hideMe");
    } else {
      lastMessage.classList.add("hideMe");
    }
  }

  updateInputLevelMeter = (vol) => {
    if (!this.volumeMeterEnabled && vol > 0) {
      const container = document.querySelector(".pids-wrapper");
      container.classList.remove("hideMe");
      this.volumeMeterEnabled = true;
    }
    if (this.volumeMeterEnabled) {
      if (this.isMicMuted) vol = 0;

      const allPids = [...document.querySelectorAll(".pid")];
      const numberOfPidsToColor = Math.round(vol / 10);
      const pidsToColor = allPids.slice(0, numberOfPidsToColor);
      for (const pid of allPids) {
        pid.style.backgroundColor = "#e6e7e8";
        pid.style.boxShadow =
          "-2px -2px 4px 0px #a7a7a73d inset, 2px 2px 4px 0px #0a0a0e5e inset";
      }
      let i = 0;
      for (const pid of pidsToColor) {
        pid.style.backgroundColor = `${ledsColorForMeter[i++]}`;
      }
    }
  };
  switchAudioMode(deviceId, saveAsDefault = true) {
    if (saveAsDefault && this.localStorage)
      this.localStorage.setAudioDeviceId(deviceId);
    this.selectedAudioDeviceId = deviceId;
    if (this.areOptionsVisible())
      measureInputLevel(this.selectedAudioDeviceId, this.updateInputLevelMeter);

    const self = this;
    const newMediaConstraints = mediaConstraintsGenerator(
      this.selectedVideoDeviceId,
      this.selectedAudioDeviceId
    );

    if (this.webRTCAdaptor && this.streamId)
      this.webRTCAdaptor
        .switchAudioInputSource(this.streamId, newMediaConstraints)
        .then(() => {
          if (self.isMicMuted) {
            setTimeout(() => {
              self.muteMic();
            }, 500);
          }
        });
  }

  getCameraRadioButton(deviceName, deviceId) {
    return `<option name="videoSource" class="video-source" value="${deviceId}" id="${deviceId}">${deviceName}</option>`;
  }

  getAudioRadioButton(deviceName, deviceId) {
    return `<option name="audioSource" class="audio-source" value="${deviceId}" id="${deviceId}">${deviceName}</option>`;
  }

  showMultipleAudioVideoDevicesErrorPopUp() {
    if (this.cameraAudioMultipleErrorsPopUp.classList.contains("hideMe"))
      this.cameraAudioMultipleErrorsPopUp.classList.remove("hideMe");
  }

  hideMultipleAudioVideoDevicesErrorPopUp() {
    if (!this.cameraAudioMultipleErrorsPopUp.classList.contains("hideMe"))
      this.cameraAudioMultipleErrorsPopUp.classList.add("hideMe");
  }

  showChangedDeviceOrientationPopup() {
    console.log("Show changed device orientation called");
    if (this.changedDeviceOrientationPopUp.classList.contains("hideMe")) {
      console.log("removing hide me class");
      this.changedDeviceOrientationPopUp.classList.remove("hideMe");
    }
  }

  hideChangedDeviceOrientationPopUp() {
    if (!this.changedDeviceOrientationPopUp.classList.contains("hideMe")) {
      console.log("adding hide me class");

      this.changedDeviceOrientationPopUp.classList.add("hideMe");
    }
  }

  areOptionsVisible() {
    if (
      this.popUpOptions &&
      this.popUpOptions.classList &&
      !this.popUpOptions.classList.contains("hideMe")
    )
      return true;
    return false;
  }
  toggleOptions() {
    if (this.areOptionsVisible()) {
      this.hideOptions();
    } else {
      this.showOptions();
    }
  }

  showOptions() {
    if (this.popUpOptions.classList.contains("hideMe")) {
      measureInputLevel(this.selectedAudioDeviceId, this.updateInputLevelMeter);

      this.popUpOptions.classList.remove("hideMe");
      this.mainConfigurationBlock.classList.remove("hideMe");
    }
  }

  hideOptions() {
    if (!this.popUpOptions.classList.contains("hideMe")) {
      stopMeasuringInputLevel();

      this.popUpOptions.classList.add("hideMe");
      this.mainConfigurationBlock.classList.remove("hideMe");
    }
  }

  hideElementBySelector(selector) {
    var startButton = document.querySelector(selector);
    if (startButton) {
      startButton.classList.add("hideMe");
    }
  }

  showElementBySelector(selector) {
    var startButton = document.querySelector(selector);
    if (startButton) {
      startButton.classList.remove("hideMe");
    }
  }

  notCompatibleDeviceError() {
    this.stopPublishing();
    this.removeLocalVideo();
    this.showElementBySelector(".atv_initialvideomessage");
    this.showElementBySelector(".atv_deviceNotSupported");
    this.hideOptions();
  }

  refreshConnectingToSameServer() {
    //Check if inside iframe
    const params = new URLSearchParams(document.location.href.split("?")[1]);

    let redirectToUrl = document.location.href;
    if (this.alreadyPublishing || this.publishImmediately)
      params.set("publishImmediately", "true");
    params.set("dontCountFailures", "true");
    if (this.showId) params.set("showId", this.showId);
    this.redirectToUrlOrDoAPostMessageIfIframizedAndInternetAvailable(
      redirectToUrl.split("?")[0] + "?" + params.toString()
    );
  }

  redirectToUrlOrDoAPostMessageIfIframizedAndInternetAvailable(
    urlToRedirectTo
  ) {
    if (window.navigator.onLine) {
      if (window.location !== window.parent.location) {
        this.messageToParent("url_redirect", { urlToRedirectTo });
        // Inside iframe
      } else {
        window.location.replace(urlToRedirectTo);
      }
    }
  }

  increaseErrorsCountAndEvaluateForwardToAnotherServer(
    forcePublishAgainAutomaticallyIfForward = false
  ) {
    if (!this.alreadyPublishing) return;
    console.log("Evaluating reconnection");
    this.consequentConnectionFailures = this.consequentConnectionFailures + 1;
    this.totalConnectionFailures = this.totalConnectionFailures + 1;

    if (
      this.consequentConnectionFailures > 3 ||
      this.totalConnectionFailures > 50
    ) {
      let redirectToUrl = document.location.href;

      if (this.avoidedServers) {
        if (!this.avoidedServers.includes(publishingServer)) {
          const newAvoidedServers =
            this.avoidedServers + "," + publishingServer;
          this.avoidedServers = newAvoidedServers;
        }
      } else {
        this.avoidedServers = publishingServer;
      }
      this.getPublishingServerFromLB(this.avoidedServers)
        .then((server) => {
          this.latestEndpointUpdatedPublishingServer = server;
          this.consequentConnectionFailures = 0;
          publishingServer = server;
          this.websocketUrl = this.generateWebSocketUrl(
            server,
            webrtcSSLPublishingPort,
            webrtcNotSSLPublishingPort,
            appName
          );

          if (forcePublishAgainAutomaticallyIfForward) this.performRepublish();
        })
        .catch(() => {
          console.log("Error trying to get streaming server");
        });

      // this.redirectToUrlOrDoAPostMessageIfIframizedAndInternetAvailable(
      // 	redirectToUrl.split('?')[0] + '?' + params.toString()
      // );

      if (this.totalConnectionFailures >= 50)
        this.redirectToUrlOrDoAPostMessageIfIframizedAndInternetAvailable(
          redirectToUrl +
            (forcePublishAgainAutomaticallyIfForward ||
            this.alreadyPublishing ||
            this.publishImmediately
              ? "&publishImmediately=true"
              : "")
        );
    }
  }

  performRepublish() {
    console.log("Performing republish");
    if (!this.alreadyPublishing) return;
    this.webRTCAdaptor.stop(this.streamId);
    this.webRTCAdaptor.closePeerConnection(this.streamId);
    this.webRTCAdaptor.changeEmitServer(this.websocketUrl);
    if (this.latestEndpointUpdatedPublishingServer)
      publishingServer = this.latestEndpointUpdatedPublishingServer;
    this.alreadyPublishing = true;
    this.initWebRTCAdaptor(true, true);
  }
  checkAndRepublishIfRequired() {
    if (!this.alreadyPublishing) return;
    var iceState = this.webRTCAdaptor.iceConnectionState(this.streamId);
    console.debug("checkAndRepublishIfRequired. Current Status:", iceState);
    if (
      iceState == null ||
      iceState === "failed" ||
      iceState === "disconnected"
    ) {
      this.increaseErrorsCountAndEvaluateForwardToAnotherServer();

      console.warn(iceState);
      this.performRepublish();
      // this.webRTCAdaptor.stop(this.streamId);
      // this.initWebRTCAdaptor();
    } else {
      let onlineText = translations.ONLINE_WARNING;
      let colorType = "SUCCESS";
      if (this.lastStats && this.lastStats.fps && this.lastStats.fps > 0) {
        onlineText = onlineText + " - " + "FPS: " + this.lastStats.fps;
        if (this.lastStats.fps < 20) colorType = "WARNING";
        if (this.lastStats.fps < 10) colorType = "ERROR";
      }

      this.__alertToVideo(onlineText, colorType);
      this.__messageToVideo(translations.PUBLISHING);
      this.lastReportedState = "PUBLISHING";
      this.consequentConnectionFailures = 0;
    }
  }

  onConnecting() {
    // this.increaseErrorsCountAndEvaluateForwardToAnotherServer();
    this.state = "CONNECTING";
    this.__messageToVideo(translations.CONNECTING);
    this.lastReportedState = "CONNECTING";
  }

  onConnected(obj) {
    this.consequentConnectionFailures = 0;
    this.state = "CONNECTED";
    if (!this.alreadyInitialized) {
      this.__messageToVideo(translations.READY);
      this.lastReportedState = "READY";
      // So it does not conflict with 'start emission' button

      if (!this.publishImmediately) this.messageToParent("initialized", obj);
      this.alreadyInitialized = true;
      if (this.isMicMuted) {
        this.muteMic();
      }
    } else if (!this.alreadyPublishing) {
      // So it does not conflict with 'start emission' button

      if (!this.publishImmediately) {
        this.lastReportedState = "READY";
        this.__messageToVideo(translations.READY);
      }
    }

    this.enableStartPublishButton();

    console.log("connected");
    if (this.publishImmediately || this.alreadyPublishing) {
      this.startPublishing();
    }
  }

  onConnectionClosed() {
    console.log("[DEBUG] Connection closed");
    if (!this.alreadyPublishing) return;
    this.increaseErrorsCountAndEvaluateForwardToAnotherServer();
    this.performRepublish();
    this.updateSignalBars(1);
    this.state = "RECONNECTING";
  }

  onPublishStarted(obj) {
    this.consequentConnectionFailures = 0;
    this.state = "PUBLISHING";
    this.messageToParent("publish_started", obj);
    this.initialOrientation = this.getOrientation(); // For comparing on mobile devices
    if (this.autoRepublishEnabled && this.autoRepublishIntervalJob == null) {
      this.autoRepublishIntervalJob = setInterval(() => {
        this.checkAndRepublishIfRequired();
      }, 5000);
    }
    this.__messageToVideo(translations.PUBLISHING);
    this.lastReportedState = "PUBLISHING";
    this.webRTCAdaptor.enableStats(obj.streamId);

    this.alreadyPublishing = true;
  }

  onPublishFinished(obj) {
    this.updateSignalBars(0);
    this.state = "STOPPED";
    this.messageToParent("publish_finished", obj);
    //stream is being finished
    console.warn("publish finished");
    // this.showMultipleAudioVideoDevicesErrorPopUp();
    this.__messageToVideo(translations.ENDED);
    this.lastReportedState = "ENDED";
    this.stopTakeCaptureIfPending();
  }

  /**
   * @param {{
   *     state: ('checking'|'connected'|'disconnected'),
   *     streamId: ''
   * }} obj
   */
  onIceConnectionStateChanged(obj) {
    this.messageToParent("ice_connection_state_changed", obj);
    console.log("iceConnectionState Changed: ", JSON.stringify(obj));
    if (obj.state === "disconnected") {
      this.updateSignalBars(1);
      this.__messageToVideo(translations.RECONNECTING);
      this.lastReportedState = "RECONNECTING";
    } else {
      this.__messageToVideo(translations.PUBLISHING);
      this.lastReportedState = "PUBLISHING";
    }
  }

  onUpdatedStats(obj) {
    if (!this.alreadyPublishing) return;
    var averageOutgoingBitrate = obj.averageOutgoingBitrate;
    var currentOutgoingBitrate = obj.currentOutgoingBitrate;
    console.log(currentOutgoingBitrate);

    if (averageOutgoingBitrate <= 0) {
      averageOutgoingBitrate = null;
    }

    if (currentOutgoingBitrate <= 0) {
      currentOutgoingBitrate = null;
    }

    let packetLost =
      parseInt(obj.videoPacketsLost) + parseInt(obj.audioPacketsLost);
    if (packetLost < 0) {
      packetLost = null;
    }
    let jitter = (
      (parseFloat(obj.videoJitter) + parseInt(obj.audioJitter)) /
      2
    ).toPrecision(3);
    if (jitter <= 0) {
      jitter = null;
    }

    let rtt = (
      (parseFloat(obj.videoRoundTripTime) +
        parseFloat(obj.audioRoundTripTime)) /
      2
    ).toPrecision(3);
    if (rtt <= 0) {
      rtt = null;
    }
    let sourceResolution = null;
    if (obj.frameHeight > 0 && obj.frameWidth > 0) {
      sourceResolution = `${obj.frameWidth}x${obj.frameHeight}`;
    }

    const connectionQualityScoring = evaluateConnectionAndReturnScoring(
      obj,
      this.lastStats,
      currentOutgoingBitrate,
      packetLost,
      rtt
    ); // Needs previous last stats to make comparisons

    this.lastStats = {
      streamName: streamName,
      publishingServer: publishingServer,
      averageBitrate: averageOutgoingBitrate,
      latestBitrate: currentOutgoingBitrate,
      packetLost: packetLost,
      jitter: jitter,
      roundTripTime: rtt,
      sourceResolution: sourceResolution,
      fps: obj.currentFPS ? parseFloat(obj.currentFPS) : null,
      qualityLimitationDurations: obj.qualityLimitationDurations,
      showId: this.showId,
    };

    this.latestUnreportedStats = {
      streamingServer: publishingServer,
      currentSessionUID: this.currentSessionUID,
      latestBitrate: currentOutgoingBitrate,
      averageBitrate: averageOutgoingBitrate,
      packetLost: packetLost,
      jitter: jitter,
      roundTripTime: rtt,
      framesPerSecond: obj.currentFPS,
      resolution: sourceResolution,
      connectionQualityScoring: connectionQualityScoring,
      qualityLimitationDurations: obj.qualityLimitationDurations,
      streamerUserAgent: navigator.userAgent,
    };

    this.updateSignalBars(connectionQualityScoring);
  }

  updateDeviceList() {
    const self = this;
    return new Promise((resolve, reject) => {
      navigator.mediaDevices
        .enumerateDevices()
        .then(function (devices) {
          let wasAnyDeviceChanged = false;
          if (devices) {
            if (!self.avaiableDevicesSent) {
              self.messageToParent("available_devices", {
                available_devices: true,
              });
              self.avaiableDevicesSent = true;
            }

            const availableInputAudioDevices = [];
            const availableInputVideoDevices = [];

            let videoHtmlContent = "";
            let audioHtmlContent = "";
            let wasDefaultVideoDeviceFound =
              devices.filter((current) => {
                return (
                  current.kind === "videoinput" &&
                  current.deviceId === self.localStorage.getVideoDeviceId()
                );
              }).length > 0;
            let wasDefaultAudioDeviceFound =
              devices.filter((current) => {
                return (
                  current.kind === "audioinput" &&
                  current.deviceId === self.localStorage.getAudioDeviceId()
                );
              }).length > 0;
            if (
              wasDefaultAudioDeviceFound &&
              self.selectedAudioDeviceId !==
                self.localStorage.getAudioDeviceId()
            ) {
              self.switchAudioMode(self.localStorage.getAudioDeviceId());
              wasAnyDeviceChanged = true;
            }
            if (
              wasDefaultVideoDeviceFound &&
              self.selectedVideoDeviceId !==
                self.localStorage.getVideoDeviceId()
            ) {
              console.log("Switch videomode after update device list");
              self.switchVideoMode(self.localStorage.getVideoDeviceId());
              wasAnyDeviceChanged = true;
            }

            let wasSelectedAudioDeviceFound =
              devices.filter((current) => {
                return (
                  current.kind === "audioinput" &&
                  current.deviceId === self.selectedAudioDeviceId
                );
              }).length > 0;

            let wasSelectedVideoDeviceFound =
              devices.filter((current) => {
                return (
                  current.kind === "videoinput" &&
                  current.deviceId === self.selectedVideoDeviceId
                );
              }).length > 0;

            let tentativeSelectedDeviceForSwitch = null;
            devices.forEach(function (device) {
              if (device.kind === "videoinput") {
                if (!wasSelectedVideoDeviceFound) {
                  if (
                    !tentativeSelectedDeviceForSwitch
                    // || device.label.includes("Virtual")
                  ) {
                    tentativeSelectedDeviceForSwitch = device.deviceId;
                    wasAnyDeviceChanged = true;
                  }
                }
                videoHtmlContent += self.getCameraRadioButton(
                  device.label,
                  device.deviceId
                );
                availableInputVideoDevices.push(device);
              } else if (device.kind === "audioinput") {
                if (!wasSelectedAudioDeviceFound) {
                  self.switchAudioMode(device.deviceId, false);
                  wasSelectedAudioDeviceFound = true;
                  wasAnyDeviceChanged = true;
                }
                audioHtmlContent += self.getAudioRadioButton(
                  device.label,
                  device.deviceId
                );
                availableInputAudioDevices.push(device);
              }
            });
            if (tentativeSelectedDeviceForSwitch) {
              // select is put behind
              wasAnyDeviceChanged = true;
              self.switchVideoMode(tentativeSelectedDeviceForSwitch, false);
            }
            while (self.videoSelector.lastElementChild) {
              self.videoSelector.removeChild(
                self.videoSelector.lastElementChild
              );
            }
            self.videoSelector.insertAdjacentHTML(
              "beforeend",
              videoHtmlContent
            );

            while (self.audioSelector.lastElementChild) {
              self.audioSelector.removeChild(
                self.audioSelector.lastElementChild
              );
            }
            self.audioSelector.insertAdjacentHTML(
              "beforeend",
              audioHtmlContent
            );

            const videoSwitchToSelect = document.getElementById(
              self.selectedVideoDeviceId
            );
            if (videoSwitchToSelect) videoSwitchToSelect.selected = true;
            const audioSwitchToSelect = document.getElementById(
              self.selectedAudioDeviceId
            );
            if (audioSwitchToSelect) audioSwitchToSelect.selected = true;

            if (wasAnyDeviceChanged) self.showOptions();

            resolve();
          } else {
            reject(new Error("No devices"));
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  onAvailableDevices(obj) {
    this.messageToParent("available_devices", obj);
    this.updateDeviceList();
  }

  initConfigButton() {
    if (this.settingsButtons) {
      this.settingsButtons.addEventListener("click", () =>
        this.toggleOptions()
      );
    }
  }

  initCaptureButton() {
    if (this.captureButton) {
      if (!areTakeLocalCaptureActionsVisible) {
        this.captureButton.classList.add("hideMe");
      } else {
        this.captureButton.addEventListener("click", () => {
          this.startTakeCaptureInterval(3);
        });
      }
    }
  }

  parseAvailableCodecs() {
    var defaultCodec = ["h264"];
    var codecs = decodeURIComponent(getUrlParameter("codecs"));
    if (!codecs || typeof codecs !== "string") {
      console.error(
        "could not parse available codecs from url: " + window.location.href
      );
      return defaultCodec;
    }

    var codecsAsArray = codecs
      .split(",")
      .map((c) => c.trim())
      .filter((c) => c);
    if (codecsAsArray.length === 0) {
      console.error(
        "could not parse available codecs from url: " + window.location.href
      );
      return defaultCodec;
    }

    return codecsAsArray;
  }
}

var ui;
(function () {
  ui = new UI();
})();

// var logErrors = getUrlParameter("logErrors");
var logErrors = "http";
var error = new ErrorLogger(logErrors);
error.onError((errorJsonData) => {
  try {
    errorJsonData.audioDevices = [].slice
      .call(document.querySelectorAll(".atv_webrtc_audio_selector option"))
      .map((d) => d.textContent);
    errorJsonData.videoDevices = [].slice
      .call(document.querySelectorAll(".atv_webrtc_video_selector option"))
      .map((d) => d.textContent);
    if (ui.webRTCAdaptor) {
      errorJsonData.mediaConstraints = ui.webRTCAdaptor.mediaConstraints;
      errorJsonData.iceConnectionState = ui.webRTCAdaptor.iceConnectionState(
        ui.streamId
      );
    }
    ui.messageToParent("error", JSON.stringify(errorJsonData));
  } catch (e) {
    console.warn(e);
  }
});
